let utils = {};

/*密码必须符合由数字,大写字母,小写字母,至少其中两种组成，且长度不小于6*/
// utils.checkPassword = (pwd) => {
//     let reg = /^(?![A-Z]+$)(?![a-z]+$)(?!\d+$)\S{6,16}$/;
//     return reg.test(pwd);
// };
// 密码必须符合由数字,大写字母,小写字母,三种组成,长度在6至16位
utils.checkPassword = (pwd) => {
    let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)(?![0-9a-z]+$)(?![0-9A-Z]+$)[0-9A-Za-z]{6,16}$/
    return reg.test(pwd);
};

/*校验是否中文名称组成 */
utils.isChinese = (str) => {
    let reg = /^[\u4E00-\u9FA5]{2,4}$/;//定义验证表达式
    return reg.test(str); //进行验证
};

/*中国手机号验证*/
utils.checkCellPhoneCN = (phoneNumber) => {
    let reg = /^1\d{10}$/;
    return reg.test(phoneNumber);
};

/*邮箱格式验证*/
utils.checkEmailFormat = (emailAddr) => {
    // let reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    let reg = /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    return reg.test(emailAddr);
};

/*文件列表数组去重-01*/
/*utils.uniqArray = (array) => {
    let temp = [];
    for (let key = 0; key < array.length; key++) {
        if (-1 == JSON.stringify(temp).indexOf(JSON.stringify(array[key]))) {
            temp.push(array[key]);
        }
    }
    return temp;
};*/


/*文件列表数组去重-02*/
utils.uniqArray = (array) => {
    let temp = [];
    for (let key = 0; key < array.length; key++) {
        if (-1 === temp.findIndex(item => item.fileName === array[key].fileName)) {
            temp.push(array[key]);
        }
    }
    return temp;
};

/*会话之间传递信息-01*/
utils.sendLocalInfo = (info) => {
    let str01 = '1at';
    let str02 = 'q2e';
    let str03 = 'tf4';
    let str04 = 'j23';
    let str05 = 'hjn';
    let str06 = '6ol';

    let str = info; //这是一字符串
    let ori01 = str.slice(0, 1);
    let ori02 = str.slice(1, 2);
    let ori03 = str.slice(2, 3);
    let ori04 = str.slice(3, 4);
    let ori05 = str.slice(4, 5);
    let ori06 = str.slice(5, 6);
    let a = str.substring(6);
    let b = ori01 + str01 + ori02 + str02 + ori03 + str03 + ori04 + str04 + ori05 + str05 + ori06 + str06 + a;
    return b;
};

/*会话之间传递信息-02*/
utils.receiveLocalInfo = (newInfo) => {
    let b = newInfo.substring(24);
    let back01 = newInfo.slice(0, 1);
    let back02 = newInfo.slice(4, 5);
    let back03 = newInfo.slice(8, 9);
    let back04 = newInfo.slice(12, 13);
    let back05 = newInfo.slice(16, 17);
    let back06 = newInfo.slice(20, 21);
    let c = back01 + back02 + back03 + back04 + back05 + back06 + b;
    return c;
};


/*验证正确的IP地址和端口号格式*/
utils.checkIPformat = (needCheckIP) => {
    let finalResult = false;
    if (needCheckIP) {
        let ipAdd = needCheckIP.split(":")[0];
        // let ipPort = needCheckIP.split(":")[1];
        let ipAddReg = RegExp(/^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/);
        // let ipPortReg = RegExp(/^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5])$/);

        let ipAddCheckResult = ipAddReg.test(ipAdd);
        // let ipPortCheckResult = ipPortReg.test(ipPort);
        (ipAddCheckResult) ? finalResult = true : finalResult = false;
    }

    return finalResult;
};

utils.currentDateTime = () => {
    /*名称_日期*/
    let dateNow = new Date();
    let myYear = dateNow.getFullYear();
    let myMonth = dateNow.getMonth() + 1;
    if (myMonth >= 1 && myMonth <= 9) {
        myMonth = '0' + myMonth;
    }
    let myDate = dateNow.getDate();
    if (myDate >= 1 && myDate <= 9) {
        myDate = '0' + myDate;
    }
    /*名称_时间*/
    let myHours = dateNow.getHours();
    if (myHours >= 1 && myHours <= 9) {
        myHours = '0' + myHours;
    }
    let myMinutes = dateNow.getMinutes();
    if (myMinutes >= 1 && myMinutes <= 9) {
        myMinutes = '0' + myMinutes;
    }
    let mySeconds = dateNow.getSeconds();
    if (mySeconds >= 1 && mySeconds <= 9) {
        mySeconds = '0' + mySeconds;
    }

    let currentTime = String(myHours) + myMinutes + mySeconds;
    let currentDate = String(myYear) + myMonth + myDate;
    let curDateTime = {
        date: currentDate,
        time: currentTime,
    };
    return curDateTime;
};

/*转换日期格式 yyyy-MM-dd*/
utils.dateFormat = (thisDate, fmt) => {
    if (thisDate) {
        var o = {
            "M+": thisDate.getMonth() + 1,
            "d+": thisDate.getDate(),
            "h+": thisDate.getHours(),
            "m+": thisDate.getMinutes(),
            "s+": thisDate.getSeconds(),
            "q+": Math.floor((thisDate.getMonth() + 3) / 3),
            "S": thisDate.getMilliseconds()
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (thisDate.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));

    }
    return fmt;
};

/*'yyyy-MM-dd hh:mm:ss'格式的字符串转日期*/
utils.stringToDate = (str) => {
    let tempStrs = str.split(" ");
    let dateStrs = tempStrs[0].split("-");
    let year = parseInt(dateStrs[0], 10);
    let month = parseInt(dateStrs[1], 10) - 1;
    let day = parseInt(dateStrs[2], 10);
    let timeStrs = tempStrs[1].split(":");
    let hour = parseInt(timeStrs[0], 10);
    let minute = parseInt(timeStrs[1], 10);
    let second = parseInt(timeStrs[2], 10);
    let date = new Date(year, month, day, hour, minute, second);
    return date;
};

utils.DateAdd = (interval, number, date) => {
    /*
      *   功能:实现VBScript的DateAdd功能.
      *   参数:interval,字符串表达式，表示要添加的时间间隔.
      *   参数:number,数值表达式，表示要添加的时间间隔的个数.
      *   参数:date,时间对象.
      *   返回:新的时间对象.
      *   var   now   =   new   Date();
      *   var   newDate   =   DateAdd( "d ",5,now);
      *---------------   DateAdd(interval,number,date)   -----------------
      */

    switch (interval) {
        case   "year"   : {
            date.setFullYear(date.getFullYear() + number);
            return date;
        }
        case   "quarter"   : {
            date.setMonth(date.getMonth() + number * 3);
            return date;
        }
        case   "month"   : {
            date.setMonth(date.getMonth() + number);
            return date;
        }
        case   "week"   : {
            date.setDate(date.getDate() + number * 7);
            return date;
        }
        case   "day"   : {
            date.setDate(date.getDate() + number);
            return date;
        }
        case   "hours"   : {
            date.setHours(date.getHours() + number);
            return date;
        }
        case   "minutes"   : {
            date.setMinutes(date.getMinutes() + number);
            return date;
        }
        case   "seconds"   : {
            date.setSeconds(date.getSeconds() + number);
            return date;
        }
        default   : {
            date.setDate(date.getDate() + number);
            return date;
        }
    }
};

utils.setCookieFunc = (name, value, seconds) => {
    if (seconds !== -1) {
        let Days = 1;
        let exp = new Date();
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toUTCString();
    } else {
        document.cookie = name + "=" + escape(value);
    }
};

utils.getCookieFunc = (key) => {
    //Cookie存储格式："key1=val1; key2=val2; key3=val3"
    let getCookie = document.cookie.replace(/[ ]/g, '');//把[ ] 换成 ''
    //通过';'分割成数组
    let resArr = getCookie.split(';');
    let res = "";
    for (let i = 0; i < resArr.length; i++) {
        let arr = resArr[i].split('=');
        //判断传入key是否找到存储对应的val
        if (arr[0] === key) {
            res = arr[1];
            break;
        }
    }
    return unescape(res);//解码
};

/*设置-带过期时间的localStorage*/
utils.localStorageSet = (name, data, expire = 2) => {
    const time = new Date().getTime() + expire * 60 * 60 * 1000; //以小时为单位
    // const time = new Date().getTime() + expire * 60 * 1000; //以分钟为单位
    const obj = {data, time};
    localStorage.setItem(name, JSON.stringify(obj));
};

/*获取-带过期时间的localStorage-isJSONorNot*/
function isJSONorNot(str) {
    if (typeof str === 'string' && '' !== str) {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }
}

utils.localStorageGet = name => {
    const storage = localStorage.getItem(name);
    const time = new Date().getTime();
    let result = false;
    if (storage && isJSONorNot(storage)) {
        const obj = JSON.parse(storage);
        if (time < obj.time) {
            result = obj.data;
        } else {
            localStorage.removeItem(name);
        }
    }
    return result;
};

utils.getQueryValue = (type, key) => {
    // 正则表达式 获取type下的字符串中key的对应值,
    const regExp = new RegExp(`[?&#]{1}${key}=(.*?)([&/#]|$)`);
    let value = null;
    // 如果匹配不到key match方法会返回null
    if ('browser' === type) {
        value = window.location.href.match(regExp);
    } else if ('hash' === type) {
        value = window.location[type].match(regExp);
    }
    return value && value[1]
};

utils.delete_cookie_all = () => {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
};

/*页面滚动方向*/
let scrollAction = {x: 'undefined', y: 'undefined'};
let scrollDirection = null;
utils.scrollFunc = () => {
    if (typeof scrollAction.x === 'undefined') {
        scrollAction.x = window.pageXOffset;
        scrollAction.y = window.pageYOffset;
    }
    let diffX = scrollAction.x - window.pageXOffset;
    let diffY = scrollAction.y - window.pageYOffset;
    if (diffX < 0) {
        scrollDirection = 'right';
    } else if (diffX > 0) {
        scrollDirection = 'left';
    } else if (diffY < 0) {
        scrollDirection = 'down';
    } else if (diffY > 0) {
        scrollDirection = 'up';
    } else {
        // First scroll event
    }
    scrollAction.x = window.pageXOffset;
    scrollAction.y = window.pageYOffset;
    return scrollDirection;
};
//用户组
utils.generateUUID=(len, charSet)=> {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomString = '';
    for (let i = 0; i < len; i++) {
        let randomPoz = Math.floor(Math.random() * charSet.length);
        randomString += charSet.substring(randomPoz,randomPoz+1);
    }
    return randomString;
};

export default utils;



// WEBPACK FOOTER //
// ./src/libs/utils.js